export default {
  date: 'Tarih',
  chooseExpDate: 'Bir tarih se\u00e7in',
  filterExpDate: 'Tarihe g\u00f6re filtrele',
  experienceType: 'T\u00fcr',
  filterExperienceType: 'T\u00fcre g\u00f6re filtrele',
  experienceVibe: 'Atmosfer',
  filterExperienceVibe: 'Atmosfere g\u00f6re filtrele',
  search: 'Ara',
  viewCalendar: 'Takvim',
  back: 'Geri',
  previous: '\u00d6nceki',
  next: 'Sonraki',
  noExperiences: 'Deneyim Yok',
  cancelChanges: 'De\u011fi\u015fiklikleri iptal et',
  saveChanges: 'De\u011fi\u015fiklikleri kaydet',
  removeFromReservation: 'Rezervasyondan kald\u0131r',
  addToCart: 'Sepete ekle',
  proceedToCheckout: '\u00d6demeye ge\u00e7',
  selectDate: 'Tarih se\u00e7in',
  startDate: 'Ba\u015flang\u0131\u00e7 tarihi',
  endDate: 'Biti\u015f tarihi',
  submit: 'G\u00f6nder',
  filterExperienceTypeScreenReader:
    'Sonu\u00e7lar\u0131 daraltmak i\u00e7in bu filtreleri kullan\u0131n. Bir filtre se\u00e7ildi\u011finde i\u00e7erik otomatik olarak g\u00fcncellenir.',
};
